// Development/sandbox configuration
const sandboxConfig = {
  products: {
    Starter: {
      productId: "prod_UXoe6wM0EV3CWd",
      priceIds: {
        monthly: "price_1TYkXiD5IfClYTl33DDlgKLm",
        annually: "price_1TYkXqD5IfClYTl3IYC9L5SX",
      },
      limits: {
        smartContracts: 2,
        basicContracts: 3,
        revisions: 30,
      },
    },
    Pro: {
      productId: "prod_UXoeOnHAilTqgX",
      priceIds: {
        monthly: "price_1TYkXzD5IfClYTl3s6SKmkMR",
        annually: "price_1TYkYED5IfClYTl39nAnonl3",
      },
      limits: {
        smartContracts: null,
        basicContracts: null,
        revisions: null,
      },
    },
    Team: {
      productId: "prod_UXoeubbIrsbWte",
      priceIds: {
        monthly: "price_1TYkYMD5IfClYTl3p8Uujspw",
        annually: "price_1TYkYfD5IfClYTl3aaVThZGL",
      },
      limits: {
        smartContracts: null,
        basicContracts: null,
        revisions: null,
      },
    },
  },
};

// Production configuration
const productionConfig = {
  products: {
    Starter: {
      productId: "prod_UMxYrqzKWsPFl0",
      priceIds: {
        monthly: "price_1TYkYuD5IfClYTl3XkUaYod5",
        annually: "price_1TYkZ2D5IfClYTl358tYPgiW",
      },
      limits: {
        smartContracts: 2,
        basicContracts: 3,
        revisions: 30,
      },
    },
    Pro: {
      productId: "prod_UMxXGEnkG6urtJ",
      priceIds: {
        monthly: "price_1TYkZ9D5IfClYTl3WHHO6hmz",
        annually: "price_1TYkZJD5IfClYTl3UBHZGlW2",
      },
      limits: {
        smartContracts: null,
        basicContracts: null,
        revisions: null,
      },
    },
    Team: {
      productId: "prod_UMxXFQdwDbPn81",
      priceIds: {
        monthly: "price_1TYkZZD5IfClYTl3OQF7U18a",
        annually: "price_1TYkZtD5IfClYTl34bepxfOj",
      },
      limits: {
        smartContracts: null,
        basicContracts: null,
        revisions: null,
      },
    },
  },
};

// Export the appropriate configuration based on environment
export const stripeConfig = import.meta.dev ? sandboxConfig : productionConfig;
